export const PositionType = {
  ALL: 0,
  TEACHER: 1,
  TEACHING_ASSISTANT: 2,
  GUARD: 3,
  CONTENT: 4,
  SALE: 5,
  MARKETING: 6,
  RECEPTIONIST: 7,
  BUSINESS_PROFESSIONAL: 8,
  EDITOR: 9,
};

export const LevelType = {
  ALL: 0,
  INTERN: 1,
  EMPLOYEE: 2,
  EXPERT: 3,
  MANAGER: 4,
};

export const WorkingFormType = {
  FULLTIME: 1,
  PARTTIME: 2,
};

export const GenderType = {
  ALL: 0,
  MALE: 1,
  FEMALE: 2,
  OTHER: 3,
};

export const POSITION_OPTIONS = [
  { title: "Tất cả vị trí", value: PositionType.ALL },
  { title: "Giáo viên", value: PositionType.TEACHER },
  { title: "Trợ giảng", value: PositionType.TEACHING_ASSISTANT },
  { title: "Content", value: PositionType.CONTENT },
  { title: "Sale", value: PositionType.SALE },
  { title: "Marketing", value: PositionType.MARKETING },
  { title: "Lễ tân", value: PositionType.RECEPTIONIST },
  { title: "Bảo vệ", value: PositionType.GUARD },
  { title: "Kinh doanh", value: PositionType.BUSINESS_PROFESSIONAL },
  { title: "Editor", value: PositionType.EDITOR },
];

export const LEVEL_OPTIONS = [
  { title: "Tất cả cấp bậc", value: LevelType.ALL },
  { title: "Thực tập", value: LevelType.INTERN },
  { title: "Nhân viên", value: LevelType.EMPLOYEE },
  { title: "Chuyên viên", value: LevelType.EXPERT },
  { title: "Quản lý", value: LevelType.MANAGER },
];

export const genderLabels = {
  [GenderType.ALL]: "Không yêu cầu",
  [GenderType.MALE]: "Nam",
  [GenderType.FEMALE]: "Nữ",
  [GenderType.ORTHER]: "Khác",
};

export const getPostionLabel = (position) =>
  POSITION_OPTIONS.find((item) => item.value === position).title ||
  "Positon not unknow";

export const getLevelLabel = (level) =>
  LEVEL_OPTIONS.find((item) => item.value === level)?.title ||
  "Level not unknow";
